import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Grid2 } from "@mui/material";
import { Search } from "@mui/icons-material";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormFiltersLiquidacionInterface } from "../interfaces";
import CustomAccordion from "../../../../components/ui/materialui/customAccordion";
import MButton from "../../../../components/inputs/yup/materialui/mButton";
import InputRut from "../../../../components/inputs/yup/materialui/inputRut";
import InputText from '../../../../components/inputs/yup/materialui/inputText';
import validaRut from "../../../../utils/validaRut";

interface FiltrosLiquidacionComponentProps {
    handleFilters: (formFilters: FormFiltersLiquidacionInterface) => void; //
};

//* Validacion del formulario
const validationSchema: yup.ObjectSchema<FormFiltersLiquidacionInterface> = yup.object().shape({
    rutCliente: yup.string().required('El rut del cliente es obligatorio').nonNullable().test('valida-rut', 'RUT inválido', function (value) {
                return validaRut.rutFormat(value);
            }).max(12, 'Máximo 12 caractéres'),
    idSolicitud: yup.string().required("El ID de la solicitud es obligatorio"),
    idOperacion: yup.string().required("El ID de la operación es obligatorio"),
    rutNuevoProveedor: yup.string().required('El rut del proveedor es obligatorio').nonNullable().test('valida-rut', 'RUT inválido', function (value) {
                return validaRut.rutFormat(value);
            }).max(12, 'Máximo 12 caractéres'),
    nombreNuevoProveedor: yup.string().required("El nombre del proveedor es obligatorio"),
});

export const FiltrosLiquidacionComponent = ({ handleFilters }: FiltrosLiquidacionComponentProps) => {

    const {
        handleSubmit,
        control,
        formState: { errors }
    } = useForm<FormFiltersLiquidacionInterface>({
        resolver: yupResolver(validationSchema),
        defaultValues: {},
    });

    const onSubmit = (data: FormFiltersLiquidacionInterface) => 
        handleFilters({ idOperacion: data.idOperacion, idSolicitud: data.idSolicitud, nombreNuevoProveedor: data.nombreNuevoProveedor, rutCliente: data.rutCliente, rutNuevoProveedor: data.rutNuevoProveedor });

    return (
        <CustomAccordion title="Filtros" expandedDefault>
            <form onSubmit={handleSubmit(onSubmit)}>

                <Grid2 container spacing={2} sx={{ 
                    marginTop: 1,
                    alignItems: "center",
                }}>

                    <Grid2 size={3}>
                        <InputRut
                            label="Rut cliente"
                            name={"rutCliente"}
                            control={control}
                            error={errors.rutCliente}
                        />
                    </Grid2>

                    <Grid2 size={3}>
                        <InputText
                            label="ID solicitud portabilidad"
                            name="idSolicitud"
                            control={control}
                            error={errors.idSolicitud}
                        />
                    </Grid2>

                    <Grid2 size={3}>
                        <InputText
                            label="ID operación portabilidad"
                            name="idOperacion"
                            control={control}
                            error={errors.idOperacion}
                        />
                    </Grid2>

                </Grid2>

                <Grid2 container spacing={2} sx={{ 
                    marginTop: 1,
                    alignItems: "center",
                }}>

                    <Grid2 size={3}>
                        <InputRut
                            label="Rut nuevo proveedor"
                            name={"rutNuevoProveedor"}
                            control={control}
                            error={errors.rutNuevoProveedor}
                        />
                    </Grid2>

                    <Grid2 size={3}>
                        <InputText
                            label="Nombre nuevo proveedor"
                            name="nombreNuevoProveedor"
                            control={control}
                            error={errors.nombreNuevoProveedor}
                        />
                    </Grid2>
                </Grid2>

                {/* Contenedor del Botón */}
                <Grid2 size={{ xs: 8 }} sx={{ 
                    marginTop: '10px',
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}>
                    <MButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        startIcon={<Search />}
                        sx={{ 
                            height: "40px", 
                            whiteSpace: "nowrap",
                            px: 3
                        }}
                    >
                        Buscar Productos
                    </MButton>
                </Grid2>
            </form>
        </CustomAccordion>
    );

}